import { Injectable } from '@angular/core';
import { ReportesRequestService } from './request/reportes-request.service';

@Injectable({
  providedIn: 'root'
})
export class ServicioOrdenesMedicasService {

  constructor( private requestUrl: ReportesRequestService  ) { }

  public async getOrdenesMedicas( params: ObjectOrdenesMedicasRequest ) {
    try {
      const response = await this.requestUrl.getRequest(
        'ordenes-medicas/data',
        [
          params.codigoBaseDatos,
          {
            'ln_unco_admsn': params.uncoAdmision,
            'ln_unco_emprsa': params.uncoEmpresa
          }

        ]
      );

      return response;

    } catch (e) {
      console.log(e);
    }

    return null;
  }
}

export interface ObjectOrdenesMedicasRequest {
  codigoBaseDatos: string;
  uncoAdmision: string;
  uncoEmpresa: string;
}

export interface OrdenesMedicasEntity {
  uncoOrden: string;
  numeroOrden: string;
  fechaOrden: string;
  descripcionOrden: string;
  enfermeraJefe: string;
  enfermera: string;
  nota: string;
  profesionalSalud: string;
  puntoAtencion: string;
  empresa: string;
}
